import React from 'react';

export function RichTextKeyboardDismissBar(): React.JSX.Element | null {
  return null;
}
